import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { SidebarService } from './../sidebar/sidebar.service'
import { Router } from '@angular/router';
import { ApiRestService } from 'src/app/services/network/api-rest.service';
import { AdminUserModule } from 'src/app/models/admin-user.model';


@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})

export class SidebarComponent implements OnInit {

    adminData: AdminUserModule;
    constructor(public sidebarservice: SidebarService,
        private apiRestService: ApiRestService,
    ) { }

    getSideBarSate() {
        return this.sidebarservice.getSidebarState();
    }

    ngOnInit() {
        console.log(this.apiRestService.getDataToken());
        this.adminData = this.apiRestService.getDataToken();
    }

}
